import React, { useEffect, useRef, useState } from "react";
import { message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  GoogleMap,
  Marker,
  Polyline,
  OverlayView,
  Polygon,
} from "@react-google-maps/api";
import { useGoogleMaps } from "../../components/GoogleMapsProvider";
import { GetShipmentPointsByID } from "../../api's/settings";
import { useSpin } from "../../components/SpinContext";
import { useToken } from "../../common/helper";
import Truck from "../../assets/images/Icon.png";
import { CustomParagraph } from "../../components";
import { lineData } from "../../common/test";
import AirportIcon from "../../assets/images/airport.png";
// import CustomPopup from '../../../components/CustomPopup';

const ShipmentMap = ({
  onPointClicked,
  height,
  shipment,
  lastCoordinates,
  clickedPointCoordinates,
  isLargeScreen,
  currentView,
}) => {
  const { isLoaded } = useGoogleMaps();
  const [points, setPoints] = useState([]);
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken } = useToken();
  const { id } = useParams();
  const [fromCoordinates, setFromCoordinates] = useState({ lat: null, lng: null });
  const [toCoordinates, setToCoordinates] = useState({ lat: null, lng: null });
  const [fromPlaceName, setFromPlaceName] = useState("");
  const [toPlaceName, setToPlaceName] = useState("");
  const navigate = useNavigate();
  const [path, setPath] = useState([]);
  const [smallMapPath, setSmallMapPath] = useState([]);
  const [showSmallPolyline, setShowSmallPolyline] = useState(false);

  const [sourcePopupPosition, setSourcePopupPosition] = useState(null);
  const [destinationPopupPosition, setDestinationPopupPosition] =
    useState(null);

  const [sourcePopupContent, setSourcePopupContent] = useState(null);
  const [destinationPopupContent, setDestinationPopupContent] = useState(null);

  const [fromPolygon, setFromPolygon] = useState(null);
  const [toPolygon, setToPolygon] = useState(null);

  const mapRef = useRef(null);

  const mapStyles = [
    {
      elementType: "geometry",

      stylers: [
        {
          color: "#ecf0f7",
        },
      ],
    },

    {
      featureType: "administrative.country",

      elementType: "geometry.stroke",

      stylers: [
        {
          color: "#818287",
        },
      ],
    },

    {
      featureType: "administrative.country",

      elementType: "labels.text.fill",

      stylers: [
        {
          color: "#000000",
        },
      ],
    },

    {
      featureType: "administrative.locality",

      elementType: "labels.text.fill",

      stylers: [
        {
          color: "#576173",
        },
      ],
    },

    {
      featureType: "administrative.locality",

      elementType: "labels.text.stroke",

      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },

    {
      featureType: "administrative.neighborhood",

      elementType: "labels.text.fill",

      stylers: [
        {
          color: "#85a0d5",
        },
      ],
    },

    {
      featureType: "administrative.neighborhood",

      elementType: "labels.text.stroke",

      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },

    {
      featureType: "administrative.province",

      elementType: "geometry.stroke",

      stylers: [
        {
          color: "#f5b2a6",
        },
      ],
    },

    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#a7e0b6",
        },
      ],
    },

    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#DEE2E8",
        },
      ],
    },

    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },

    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#859ad0",
        },
      ],
    },

    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },

    {
      featureType: "transit.station.airport",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#cad4e0",
        },
      ],
    },

    {
      featureType: "water",
      stylers: [
        {
          color: "#c6dbff",
        },
      ],
    },
  ];

  useEffect(() => {
    setFromPlaceName("");
    setToPlaceName("");
    setPoints([]);
    if (shipment) {
      setFromCoordinates(
        shipment?.from_location?.latlng
          ? shipment?.from_location?.latlng
          : { lat: null, lng: null }
      );
      setToCoordinates(
        shipment?.to_location?.latlng
          ? shipment?.to_location?.latlng
          : { lat: null, lng: null }
      );
      if (shipment?.shipment_monitor && shipment?.shipment_monitor.length > 0) {
        setPoints(shipment?.shipment_monitor);
      }
   const fromName = shipment?.from_location?.name;
const toName = shipment?.to_location?.name;

setFromPlaceName(
  typeof fromName === "string" && fromName.toLowerCase() === "unknown location"
    ? [
        shipment?.from_location?.parsed_address?.PlaceName || "",
        shipment?.from_location?.parsed_address?.StateName || "",
      ]
        .filter((part) => part)
        .join(", ")
    : fromName || ""
);



      // setFromPlaceName(
      //   shipment?.from_location?.name.toLowerCase() === "unknown location"
      //     ? shipment?.from_location?.parsed_address?.PlaceName +
      //         "," +
      //         shipment?.from_location?.parsed_address?.StateName
      //     : shipment?.from_location?.name
      // );
      // setToPlaceName(
      //   shipment?.to_location?.name.toLowerCase() === "unknown location"
      //     ? (shipment?.to_location?.parsed_address?.PlaceName ? shipment?.to_location?.parsed_address?.PlaceName  : "")  +
      //         "," +
      //         (shipment?.to_location?.parsed_address?.StateName ? shipment?.to_location?.parsed_address?.StateName : "")
      //     : (shipment?.to_location?.name ? shipment?.to_location?.name : "")
      // );

setToPlaceName(
  typeof toName === "string" && toName.toLowerCase() === "unknown location"
    ? [
        shipment?.to_location?.parsed_address?.PlaceName || "",
        shipment?.to_location?.parsed_address?.StateName || "",
      ]
        .filter((part) => part)
        .join(", ")
    : toName || ""
);

      setFromPolygon(shipment?.from_location?.polygon);
      setToPolygon(shipment?.to_location?.polygon);
    }
  }, [shipment]);

  useEffect(() => {
    if (fromCoordinates && toCoordinates && points?.length == 0) {
      setShowSmallPolyline(true);
      let arr = [];
      if (fromCoordinates?.lat && fromCoordinates?.lng) {
        arr.push({ lat: fromCoordinates.lat, lng: fromCoordinates.lng });
      }
      if (toCoordinates?.lat && toCoordinates?.lng) {
        arr.push({ lat: toCoordinates?.lat, lng: toCoordinates?.lng });
      }
      if (arr.length > 0) {
        setSmallMapPath(arr);
      }
    } else {
      setShowSmallPolyline(false);
      setSmallMapPath([]);
    }
  }, [points, toCoordinates, fromCoordinates]);

  useEffect(() => {
    setPath([]);
    if (points.length > 0 && toCoordinates?.lat && toCoordinates?.lng) {
      let last = {
        lat: points[points.length - 1]?.latitude,
        lng: points[points.length - 1]?.longitude,
      };
      let arr = [];
      if (last.lat && last.lng) {
        arr.push({ lat: last?.lat, lng: last?.lng });
      }
      if (toCoordinates?.lat && toCoordinates?.lng) {
        arr.push({ lat: toCoordinates?.lat, lng: toCoordinates?.lng });
      }
      if (arr.length > 0) {
        setPath(arr);
      }
    }
  }, [toCoordinates, points]);

  // useEffect(() => {
  //   if (id) {
  //     GetShipmentMonitor(id);
  //   }
  // }, [id]);

  useEffect(() => {
    setSourcePopupContent(null);
    setSourcePopupPosition(null);
    if (fromCoordinates.lat && fromCoordinates.lng) {
      setSourcePopupPosition(fromCoordinates);
      setSourcePopupContent(
        <CustomParagraph
          ellipsis={true}
          text={fromPlaceName}
          fontSize={14}
          fontWeight={600}
          marginBottom={0}
        />
      );
    }
  }, [fromCoordinates]);

  useEffect(() => {
    setDestinationPopupContent(null)
    setDestinationPopupPosition(null)
    if (toCoordinates.lat && toCoordinates.lng) {
      setDestinationPopupPosition(toCoordinates);
      setDestinationPopupContent(
        <CustomParagraph
          ellipsis={true}
          text={toPlaceName}
          fontSize={14}
          fontWeight={600}
          marginBottom={0}
        />
      );
    }
  }, [toCoordinates]);

  // const GetShipmentMonitor = (id) => {
  //   showSpin();
  //   GetShipmentPointsByID(token, id)
  //     .then((res) => {
  //       if (res) {
  //         const data = res?.data ? res.data : null;
  //         if (data) {
  //           if (data?.data?.is_success) {
  //             let resp = data?.data?.data ? data?.data?.data : null;
  //             if (resp && resp.length > 0) {
  //               setPoints(resp);
  //             }
  //           } else {
  //             message.error(data?.data?.message);
  //           }
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       unauthorize(error);
  //     })
  //     .finally(() => {
  //       hideSpin();
  //     });
  // };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const polylineOptions = {
    strokeColor: "#266EF1",
    strokeOpacity: 1.0,
    strokeWeight: 2,
    fillColor: "#266EF1",
    icons: [
      {
        icon: {
          path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 2,
          strokeColor: "#266EF1",
          fillColor: "#266EF1",
        },
        offset: "50%",
        repeat: "100px",
      },
    ],
  };

  const polylinePath = {
    strokeColor: "#4b4b4b",
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: "#4b4b4b",
    icons: null,
  };

  var markerSize = {
    url: Truck,
    scaledSize: new window.google.maps.Size(40, 40),
  };

  const mapContainerStyle = {
    width: "100%",
    height: height || "320px",
  };

  const circleIcon = {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: "#266EF1",
    fillOpacity: 1,
    strokeColor: "#266EF1",
    strokeWeight: 2,
    scale: 4,
  };

  const blackMarker = {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: "#4B4B4B",
    fillOpacity: 1,
    strokeColor: "#4B4B4B",
    strokeWeight: 2,
    scale: 10,
  };

  const whiteMarker = {
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: "#fff",
    fillOpacity: 1,
    strokeColor: "#4B4B4B",
    strokeWeight: 3,
    scale: 10,
  };

  const getCurrentPoint = (item) => {
    onPointClicked(item);
  };

  const center =
    clickedPointCoordinates &&
      clickedPointCoordinates?.lat &&
      clickedPointCoordinates?.lng
      ? clickedPointCoordinates
      : points.length
        ? {
          lat: points[points.length - 1]?.latitude,
          lng: points[points.length - 1]?.longitude,
        }
        : lastCoordinates && lastCoordinates?.lat && lastCoordinates?.lng
          ? lastCoordinates
          : fromCoordinates && fromCoordinates?.lat && fromCoordinates?.lng
            ? fromCoordinates
            : { lat: 40.7128, lng: -74.006 };

  useEffect(() => {
    if (isLoaded && fromCoordinates && toCoordinates) {
      const bounds = new window.google.maps.LatLngBounds();
      // Extend bounds to include fromCoordinates and toCoordinates
      const isValidCoordinate = (val) => typeof val === "number" && val !== 0;

      if (
        isValidCoordinate(fromCoordinates?.lat) &&
        isValidCoordinate(fromCoordinates?.lng)
      ) {
        bounds.extend(fromCoordinates);
      }

      if (
        isValidCoordinate(toCoordinates?.lat) &&
        isValidCoordinate(toCoordinates?.lng)
      ) {
        bounds.extend(toCoordinates);
      }

      points.forEach((point) => {
        if (
          isValidCoordinate(point.latitude) &&
          isValidCoordinate(point.longitude)
        ) {
          bounds.extend({ lat: point.latitude, lng: point.longitude });
        }
      });

      // Fit the map to the calculated bounds
      if (mapRef.current) {
        mapRef.current.fitBounds(bounds);
        // if (mapRef?.current && typeof mapRef?.current?.getZoom === 'function') {
        //   const currentZoom = mapRef.current.getZoom();

        //   if (typeof currentZoom === 'number' && currentZoom > 4) {
        //     mapRef.current.setZoom(currentZoom - 4);
        //   }
        // }

      }
    }
  }, [isLoaded, fromCoordinates, toCoordinates, points]);

  //All code relative to summary view
  const [currentMapView, setCurrentMapView] = useState("summary");
  const [courierTrack, setCourierTrack] = useState([]);

  useEffect(() => {
    setCurrentMapView(currentView ? currentView : "summary");
  }, [currentView]);

  useEffect(() => {
    if (currentView == "summary") {
      if (
        shipment &&
        shipment?.shipment_polyline &&
        shipment?.shipment_polyline?.length > 0
      ) {
        setCourierTrack(
          shipment?.shipment_polyline.filter(
            (item) =>
              item?.polyline &&
              item?.polyline?.length > 0 &&
              item.status == "travelled"
          )
        );
      }
    } else {
      setCourierTrack([]);
    }
  }, [shipment, currentMapView]);

  const airMarker = {
    url: AirportIcon,
    scaledSize: new window.google.maps.Size(30, 30),
  };

  return (
    <>
      {isLoaded ? (
        // <GoogleMap
        //   mapContainerStyle={mapContainerStyle}
        //   center={mapCenter}
        //   zoom={mapZoom}
        // >
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          options={{
            disableDefaultUI: !isLargeScreen, // Disables map controls if not large screen
            zoomControl: isLargeScreen, // Only show zoom control on large screens
            streetViewControl: isLargeScreen, // Only show street view control on large screens
            mapTypeControl: isLargeScreen, // Only show map type control on large screens
            styles: mapStyles,
          }}
          onLoad={(map) => {
            mapRef.current = map;
          }} // Set the map instance
        >
          {fromCoordinates && fromCoordinates?.lat && fromCoordinates?.lng && (
            <>
              {isLargeScreen ? (
                <>
                  {fromPolygon ? (
                    <Polygon
                      paths={fromPolygon}
                      options={{
                        fillColor: "#FF0000",
                        fillOpacity: 0.35,
                        strokeColor: "#FF0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                      }}
                    />
                  ) : null}

                  <Marker position={fromCoordinates} icon={blackMarker} />
                </>
              ) : (
                <Marker position={fromCoordinates} icon={blackMarker} />
              )}
            </>
          )}

          {toCoordinates && toCoordinates?.lat && toCoordinates?.lng  && (
            <>
              {isLargeScreen ? (
                <>
                  {toPolygon ? (
                    <Polygon
                      paths={toPolygon}
                      options={{
                        fillColor: "#FF0000",
                        fillOpacity: 0.35,
                        strokeColor: "#FF0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                      }}
                    />
                  ) : null}

                  <Marker position={toCoordinates} icon={whiteMarker} />
                </>
              ) : (
                <Marker position={toCoordinates} icon={whiteMarker} />
              )}
            </>
          )}

          {sourcePopupPosition && (
            <OverlayView
              position={sourcePopupPosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div className="custom-popup-info-window">
                {sourcePopupContent}
              </div>
            </OverlayView>
          )}

          {destinationPopupPosition && (
            <OverlayView
              position={destinationPopupPosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div className="custom-popup-info-window destination-popup-window">
                {destinationPopupContent}
              </div>
            </OverlayView>
          )}

          {currentMapView == "detail" ? (
            <>
              {lastCoordinates && lastCoordinates?.lat && lastCoordinates?.lng && (
                <Marker position={lastCoordinates} icon={markerSize} />
              )}

              {/* {path.length > 0 && (<Polyline path={path} options={polylinePath} />)} */}

              {showSmallPolyline && smallMapPath.length > 0 && (
                <Polyline path={smallMapPath} options={polylinePath} />
              )}
              {/* {toCoordinates && (
            <Marker
              position={toCoordinates}
              icon={blackMarker}
            />
          )} */}

              {/* {toCoordinates && (
            <>
              {fromPolygon ? (
                <Polygon
                  paths={toPolygon}
                  options={{
                    fillColor: "#FF0000",
                    fillOpacity: 0.35,
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                  }}
                />
              ) : (
                <Marker
                  position={toCoordinates}
                  icon={blackMarker}
                />
              )}
            </>
          )} */}

              {points?.length > 1 && (
                <Polyline
                  path={points
                    .filter(
                      (point) =>
                        typeof point.latitude === "number" &&
                        typeof point.longitude === "number" &&
                        point.latitude !== 0 &&
                        point.longitude !== 0
                    )
                    .map((point) => ({
                      lat: point.latitude,
                      lng: point.longitude,
                    }))}
                  options={polylineOptions}
                />
              )}

              {points?.length > 0 &&
                points
                  ?.filter(
                    (location) =>
                      typeof location.latitude === "number" &&
                      typeof location.longitude === "number" &&
                      location.latitude !== 0 &&
                      location.longitude !== 0
                  )
                  .map((location, index) => (
                    <React.Fragment key={index}>
                      <Marker
                        onClick={() => getCurrentPoint(location)}
                        position={{
                          lat: location.latitude,
                          lng: location.longitude,
                        }}
                        icon={circleIcon}
                      />
                    </React.Fragment>
                  ))}
            </>
          ) : (
            <>
              {courierTrack?.length > 0 &&
                courierTrack.map((element, index) => {
                  let courierPath = [];

                  if (element?.polyline && element.polyline.length > 0) {
                    courierPath = element.polyline
                      .filter(
                        (point) =>
                          typeof point.latitude === "number" &&
                          typeof point.longitude === "number" &&
                          point.latitude !== 0 &&
                          point.longitude !== 0
                      )
                      .map((point) => ({
                        lat: point.latitude,
                        lng: point.longitude,
                        ...point,
                      }));
                  }

                  const mode = element.mode;

                  return (
                    <React.Fragment key={index}>
                      {/* Render Polyline */}
                      <Polyline
                        path={courierPath}
                        options={
                          mode === "air" ? polylinePath : polylineOptions
                        }
                      />

                      {/* Render Marker for each valid point */}
                      {courierPath.map((point, idx) => (
                        <Marker
                          key={idx}
                          position={{ lat: point.lat, lng: point.lng }}
                          icon={mode === "air" ? airMarker : circleIcon}
                          onClick={() => getCurrentPoint(point)}
                        />
                      ))}
                    </React.Fragment>
                  );
                })}
            </>
          )}
        </GoogleMap>
      ) : (
        <h1 style="">Loading...</h1>
      )}
    </>
  );
};

export default ShipmentMap;
